<form class="form-b4a" [formGroup]="form" (ngSubmit)="submit()">
  <ng-container *ngIf="fullRefund">
    <p class="confirmation-message">
      Confirma o cancelamento completo do pedido
      <strong>{{ order.orderNumber || order.id }}</strong
      >?
    </p>
  </ng-container>

  <ng-container *ngIf="!fullRefund">
    <p class="section-label">Selecione os produtos a cancelar:</p>
    <div class="product-list">
      <div class="product-item" *ngFor="let item of lineItems">
        <p-checkbox
          [binary]="true"
          [ngModel]="isSelected(item.EAN)"
          [ngModelOptions]="{ standalone: true }"
          (onChange)="toggleProduct(item.EAN, $event.checked)"
          [inputId]="'product-' + item.EAN"
        />
        <img
          class="product-item__image"
          [src]="getProductImage(item)"
          [alt]="item.name"
        />
        <label class="product-item__name" [for]="'product-' + item.EAN">
          {{ item.name }}
        </label>
      </div>
    </div>
  </ng-container>

  <span class="option-toggle">
    <label for="shouldRefund">Realizar estorno</label>
    <p-inputSwitch formControlName="shouldRefund" inputId="shouldRefund" />
  </span>

  <ng-container *ngIf="!fullRefund">
    <span class="option-toggle">
      <label for="shouldResend">Realizar reenvio *</label>
      <p-inputSwitch formControlName="shouldResend" inputId="shouldResend" />
    </span>
    <small class="option-hint">
      * marque para reenviar produto(s) não cancelado(s)
    </small>
  </ng-container>

  <span class="p-float-label full-w">
    <textarea
      id="motivo"
      rows="5"
      cols="80"
      pInputTextarea
      formControlName="motivo"
      name="motivo"
      required
    ></textarea>
    <label for="motivo">Motivo *</label>
    <small
      [class.danger]="
        form.controls.motivo.touched &&
        form.controls.motivo.dirty &&
        !form.controls.motivo.valid
      "
    >
      {{ form.value.motivo?.length || 0 }}/200 caracteres
    </small>
  </span>

  <span class="buttons">
    <p-button
      type="button"
      label="Cancelar"
      severity="secondary"
      (onClick)="ref.close()"
    />
    <p-button
      type="submit"
      label="Confirmar"
      severity="danger"
      [disabled]="!canSubmit"
    />
  </span>
</form>
<p-confirmDialog />
